<template>
  <b-card>
    <b-tabs @activate-tab="changeTabs($event)" content-class="mt-3">
      <b-tab title="گزارش تسویه ها" active>
        <div>
          <list-table
            :fields="fields"
            :url="url"
            :excelroute="true"
            :params="params"
          ></list-table>
        </div>
      </b-tab>
      <b-tab title="مانده ها">
        <creditors v-if="enable"></creditors>
      </b-tab>
    </b-tabs>
  </b-card>
</template>
<script>
import TableShowData from "@/components/table";
import persianDate from "@/helpers/persianDate";
import { GET_USER_LIST } from "@/core/services/store/getUserList.module";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import bankDeposit from "./BankDeposit.vue";
export default {
  name: "AccountersReportSharing",

  data() {
    return {
      url: "accounters-report/sharings",
      enable:false,
      fields: [
        {
          key: "request_date",
          label: "تاریخ درخواست",
          formatter(value, key, item) {
            return persianDate.getDate(value);
          },
        },
        {
          key: "website_name",
          label: "نام وبسایت",
        },
        {
          key: "nickname",
          label: "نام و نام خانوادگی",
        },

        {
          key: "shaba_number",
          label: "شماره شبا",
        },
        {
          key: "tracking_number",
          label: "کد رهگیری",
        },
        {
          key: "amount",
          label: "مبلغ (ریال)",
          formatter(value, key, item) {
            return Number(value).toLocaleString();
          },
          tdClass(value, key, item) {
            if (item.amount > 0) {
              return "text-success";
            }
            return "text-danger";
          },
        },
        {
          key: "karmozd",
          label: "کارمزد",
          formatter(value, key, item) {
            return Number(value).toLocaleString();
          },
          tdClass(value, key, item) {
            if (item.amount > 0) {
              return "text-success";
            }
            return "text-danger";
          },
        },
        {
          key: "parent_id",
          label: "وضعیت",
          formatter(value, key, item) {
            switch (value) {
              case null: {
                if (item.amount > 0) {
                  return "شارژ حساب";
                } else {
                  return "در دست بررسی";
                }
              }
              case -1:
                return "لغو شده";
              default:
                return "انجام شده";
            }
          },
        },
        {
          key: "submit_date",
          label: "تاریخ واریز",
          formatter(value, key, item) {
            return value != null ? persianDate.getDate(value) : "-";
          },
        },
        {
          key: "source_name",
          label: "بانک مبدا",
        },
        {
          key: "totalsum",
          label: "مانده حساب (ریال)",
          formatter(value, key, item) {
            return value ? Number(value).toLocaleString() : 0;
          },
        },
      ],

      params: [
        {
          label: "از تاریخ:",
          field: "datefrom",
          type: "date-picker",
        },
        {
          label: "تا تاریخ:",
          field: "dateto",
          type: "date-picker",
        },
        {
          label: "پذیرنده",
          field: "user_id",
          type: "select",
          value: null,
          options: [],
        },
        {
          label: "تاریخ واریز از:",
          field: "submit_datefrom",
          type: "date-picker",
        },
        {
          label: "تاریخ واریز تا:",
          field: "submit_dateto",
          type: "date-picker",
        },
        {
          label: "کد رهگیری:",
          field: "tracking_number",
          type: "text",
        },
        {
          label: "شماره شبا:",
          field: "shaba_number",
          type: "text",
        },
      ],
    };
  },
  components: {
    "list-table": TableShowData,
    creditors: bankDeposit,
  },
  computed: {
    loadedUserList() {
      return this.$store.getters.loadedUserList;
    },
  },

  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      {
        title: "گزارشات مالی",
        route: "merchants",
      },
      {
        title: "تسهیم ها",
      },
    ]);
    this.getUserList();
  },
  methods: {
    getUserList() {
      this.$store.dispatch(GET_USER_LIST, "users-with-sharing").then((data) => {
        let option = [{ text: "انتخاب نشده", value: null }];
        data.forEach((element) => {
          option.push({
            text: element.name + " ( " + element.mobile + " )",
            value: element.id,
          });
        });

        this.params[2].options = option;
      });
    },
    changeTabs(e){
      e==1 ? this.enable=true : null;
    }
  },
};
</script>